import { ReactElement, useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  CdkHeader,
  DfrontUiLateralMenu,
  DfrontUiProfile,
} from 'renfe-components';
import {
  menuItemsAdministrador,
  menuItemsSupervisor,
  menuItemsVisualizador,
  menuItemsAlumno,
  menuItemsAlumnoExtActive,
  menuItemsAlumnoIntActive,
  menuItemsFormador,
  menuItemsGestor,
  menuItemsInstructor,
  menuItemsInstructorActive,
} from 'containers/Header/header-items';
import { makeSelectTokenAccessToken } from 'store/oauth/selectors';
import { useHistory } from 'react-router-dom';
import { DatosPerfilesUsuario } from 'store/usuarios/types';
import { createStructuredSelector } from 'reselect';
import {
  makeSelectGetUserPhoto,
  makeSelectPerfilesUsuario,
  makeSelectPerfilesUsuarioDatosPerfilesUsuario,
  makeSelectPerfilesUsuarioDatosPerfilesUsuarioPerfilesParsed,
  makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected,
} from 'store/usuarios/selectors';
import {
  getPerfilesUsuarioRequest,
  getUserPortraitRquest,
} from 'store/usuarios/actions';
import {
  resetState,
  resetToken,
  setForbiddenAccess,
} from 'store/oauth/actions';
import { RouteTypes, TxtTypes } from 'consts';
import { resetCreatePracticeForm, setProfileSelected } from 'store/app/actions';
import { resetPracticaSeleccionada } from 'store/practicas/actions';
import { logOut } from 'utils/fetcher/tokenGuard';
import './header.scss';
import { APP_HEADER_PAGETITLE, APP_VERSION_TAG} from 'variables';

const selectors: any = createStructuredSelector({
  datosPerfilesUsuario: makeSelectPerfilesUsuarioDatosPerfilesUsuario(),
  perfilesUsuarioPerfilesParsed:
    makeSelectPerfilesUsuarioDatosPerfilesUsuarioPerfilesParsed(),
  perfilesUsuario: makeSelectPerfilesUsuario(),
  access_token: makeSelectTokenAccessToken(),
  profileSelected: makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected(),
  userPhoto: makeSelectGetUserPhoto(),
} as any);

const Header = (): ReactElement => {
  const history = useHistory();
  const dispatch = useDispatch();

  const appVersion = APP_VERSION_TAG;

  const {
    datosPerfilesUsuario,
    perfilesUsuarioPerfilesParsed,
    perfilesUsuario,
    access_token,
    profileSelected,
    userPhoto,
  } = useSelector<any, any>(selectors);

  const [menuItem, setMenuItem] = useState<Array<any>>([]);

useEffect(() => {
  const insertVersion = (): boolean => {
    const lateralMenuList = document.querySelector(
      'div.ui-lateral-menu ul.ui-lateral-menu__list'
    );

    if (!lateralMenuList) {
      return false;
    }

    const versionElement = lateralMenuList.querySelector(
      '.app-version-menu'
    );

    if (versionElement) {
      return true;
    }

    const newVersionElement = document.createElement('li');
    newVersionElement.className = 'app-version-menu';
    //newVersionElement.textContent = `Versión: ${appVersion}`;
    newVersionElement.textContent = `${appVersion}`;

    lateralMenuList.prepend(newVersionElement);

    return true;
  };

  // Si el menú ya existe, lo insertamos y no necesitamos observar nada
  if (insertVersion()) {
    return;
  }

  // Si Stencil todavía no lo ha creado, esperamos hasta que aparezca
  const observer = new MutationObserver(() => {
    if (insertVersion()) {
      observer.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  return () => {
    observer.disconnect();

    document
      .querySelector('.app-version-menu')
      ?.remove();
  };
}, [appVersion, menuItem]);
  

  useEffect(() => {
    document.body.addEventListener('mousemove', () => {
      const aux = document.querySelector(
        'div.ui-lateral-menu > button.ui-lateral-menu__menu-button'
      );
      const isContained = aux?.classList.contains(
        'ui-lateral-menu__menu-button--open'
      );
      if (!isContained) {
        const uls = document.querySelectorAll(
          'div.ui-lateral-menu ul.ui-lateral-menu__sublink-list--open'
        );
        uls.forEach((ul) => {
          ul.classList.remove('ui-lateral-menu__sublink-list--open');
        });
      }
    });
  }, []);

  useEffect(() => {
    if (access_token) {
      dispatch(getPerfilesUsuarioRequest());
    }
  }, [access_token, dispatch]);

  const groupProfileType = useCallback((profile: string, active: boolean) => {
    let profileActive = profile;
    if (['122', '121', '112', '123', '111'].indexOf(profile) >= 0) {
      if (active) {
        if (['122', '121', '123'].indexOf(profile) >= 0) {
          profileActive = 'alumnoExtActive';
        } else {
          profileActive = 'alumnoIntActive';
        }
      } else {
        profileActive = 'alumno';
      }
    } else if (['211'].indexOf(profile) >= 0) {
      if (active) {
        profileActive = 'instructorActive';
      } else {
        profileActive = 'instructor';
      }
    }
    return profileActive;
  }, []);

  useEffect(() => {
    if (profileSelected) {
      const profAct = groupProfileType(
        profileSelected?.ID_PERFIL,
        profileSelected?.ACTIVO === 'S'
      );
      switch (profAct) {
        case 'alumnoExtActive':
          setMenuItem(menuItemsAlumnoExtActive);
          break;
        case 'alumnoIntActive':
          setMenuItem(menuItemsAlumnoIntActive);
          break;
        case 'alumno':
          setMenuItem(menuItemsAlumno);
          break;
        case '511':
          setMenuItem(menuItemsAdministrador);
          break;
        case '611':
          setMenuItem(menuItemsSupervisor);
          break;
        case '711':
          setMenuItem(menuItemsVisualizador);
          break;    
        case '311':
          setMenuItem(menuItemsFormador);
          break;
        case '411':
          setMenuItem(menuItemsGestor);
          break;
        case 'instructorActive':
          setMenuItem(menuItemsInstructorActive);
          break;
        case 'instructor':
          setMenuItem(menuItemsInstructor);
          break;
        default:
          setMenuItem([]);
      }
    }
  }, [profileSelected, dispatch, groupProfileType]);


  useEffect(() => {
    if (profileSelected) {
      dispatch(getUserPortraitRquest());
    }
  }, [profileSelected]);

  const signOff = () => {
    logOut();
    history.push(RouteTypes.LOGIN);
  };

  const redirect = (data: any) => {
    history.push(data.detail);
    dispatch(resetCreatePracticeForm());
    dispatch(resetPracticaSeleccionada());
  };

  const handleOnChangeProfile = useCallback(
    (e) => {
      const { detail } = e; // ID_PERFIL
      const selectedIndex = datosPerfilesUsuario.findIndex((data: DatosPerfilesUsuario) => String(data?.ID_PERFIL) === String(detail));

      if (selectedIndex < 0) {
        return;
      }

      history.push({
        pathname: RouteTypes.CHANGE_PROFILE,
        state: { selectedIndex, selectedId: detail },
      });
    },
    [datosPerfilesUsuario, history]
  );

  useEffect(() => {
    const datosPerfilesUsuario = perfilesUsuario.DATOS_PERFILES_USUARIO;
    const perfiles = perfilesUsuario.PERFILES;

    if (!datosPerfilesUsuario.length && !perfiles.length) {
      return;
    }

    const noProfiles = !datosPerfilesUsuario.length;
    const numberOfPerfilCondition = false;
    const urlCondition = !checkProfilesWithURL(datosPerfilesUsuario);

    if (noProfiles || numberOfPerfilCondition || urlCondition) {
      dispatch(setForbiddenAccess(TxtTypes.TXT_LOGIN_FORBIDDEN_ACCESS));
      logOut();
      history.push(RouteTypes.LOGIN);
    }
  }, [perfilesUsuario]);

  return (
    <header>
      <CdkHeader headerText={APP_HEADER_PAGETITLE} headerTextMobile="GFM">
        <DfrontUiLateralMenu
          slot="menu"
          items={JSON.stringify(menuItem)}
          onNavigation={(e: any) => redirect(e)}
        />

        <DfrontUiProfile
          slot="profiles"
          photo={userPhoto}
          name={profileSelected?.NOMBRE_USUARIO}
          profiles={perfilesUsuarioPerfilesParsed}
          onChangeProfile={handleOnChangeProfile}
          onLogout={signOff}
        />
      </CdkHeader>

    </header>
  );
};
/**
 * @description function that check if the profiles and url match.
 * @param datosPerfilesUsuario
 * @returns {boolean} if is alowed or not.
 */
export function checkProfilesWithURL(datosPerfilesUsuario: any): boolean {
  const url = window.location.href;

  if (window.location.port === '3000' || window.location.port === '3001') {
    return true;
  }

  if (url.indexOf('gfm') >= 0) {
    return true;
  }
  return false;
}

export default Header;
